import { getInboxId } from 'conversations-thread-data/thread-details/public/operators';
/**
 * Thread context utilities for performance optimization.
 *
 * These utilities allow components to use pre-provided values from threadContext
 * when available, falling back to extracting from threadDetails when not.
 *
 * Currently threadContext is only used by help desk.
 * Conversations-inbox continues to extract data from threadDetails.
 */

export function getInboxIdFromThreadContextOrDetails(threadContext, threadDetails) {
  var _threadContext$inboxI;
  return (_threadContext$inboxI = threadContext === null || threadContext === void 0 ? void 0 : threadContext.inboxId) !== null && _threadContext$inboxI !== void 0 ? _threadContext$inboxI : getInboxId(threadDetails);
}